// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { NativeError } from '../constants/minification/native-error.const.mjs';
/**
 * An error thrown from operations within the {@link ContainerRegistry}.
 *
 * @group Errors
 *
 * @see {@link ContainerRegistry}
 */
export class ContainerRegistryError extends NativeError {
    constructor(message) {
        super(message);
        this.name = 'ContainerRegistryError';
    }
}
//# sourceMappingURL=container-registry-error.error.mjs.map